import { ElementType } from "@/constants/tagular/main";

/**
 * Common verified certificate tag configuration
 */
export const VERIFIED_CERTIFICATE_TAG = {
  text: "Verified Certificate",
  color: "fern" as const,
  borderless: true,
  icon: "certificate" as const,
};

/**
 * Element event configurations for abandoned cart components
 */
export const ABANDONED_CART_EVENT_CONFIGS = {
  modal: {
    elementType: ElementType.Modal,
    htmlId: "modal",
    location: "abandoned-cart-modal",
    name: "pop-up-modal",
    text: "In your cart",
  },
  modalCtaButton: {
    elementType: ElementType.Button,
    htmlId: "modal",
    location: "abandoned-cart-modal",
    name: "checkout-click",
    text: "Go to cart",
  },
  modalCloseButton: {
    elementType: ElementType.Modal,
    htmlId: "modal",
    location: "abandoned-cart-modal",
    name: "exit-button",
    text: "Exit Modal",
  },
  cartPopupButton: {
    elementType: "Cart" as const,
    htmlId: "cart",
    location: "nav-bar",
    name: "checkout-click",
    // text will be provided dynamically
  },
} as const;
